import { faArrowLeft } from '@fortawesome/pro-light-svg-icons';
import {
  BaseFunctionProps,
  FontAwesomeButton,
  InputItem,
  PageTitle,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import { useOrganization } from '@foxtrotplatform/platform-micro-site-core';
import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';

import { DeveloperOrganizationContextProps } from '../../../common/providers/types';

export const OrganizationInformation: FunctionComponent<BaseFunctionProps> = ({
  className,
}): JSX.Element | null => {
  const navigate = useNavigate();
  const { currentOrg: organization } =
    useOrganization() as DeveloperOrganizationContextProps;

  return (
    <div className={className}>
      <div className="flex flex-row items-center gap-x-3 pb-os1-spacing">
        <div className="border border-gary-100 w-7 h-7 pt-px pl-1.5 rounded-md">
          <FontAwesomeButton icon={faArrowLeft} onClick={() => navigate(-3)} />
        </div>
        <PageTitle>Organization Information</PageTitle>
      </div>
      <div className="flex flex-row items-center gap-x-3">
        <InputItem title="Name">
          {organization?.type === 'business' && (
            <div>{organization?.companyName}</div>
          )}
          {organization?.type === 'individual' && (
            <div>
              {organization?.firstName} {organization?.lastName}
            </div>
          )}
        </InputItem>
        <div className="h-11 border-r mb-2" />
        <InputItem title="Website">
          <div>{organization?.website}</div>
        </InputItem>
        <div className="h-11 border-r mb-2" />
        <InputItem title="Country">
          <div>{organization?.country}</div>
        </InputItem>
      </div>
    </div>
  );
};
